import { CardHeader } from '@statsbomb/kitbag-components';
import { ExpandVideoButton } from '@/components/button/ExpandVideoButton';
import { DataLockerEventsTable } from '@/components/dataLocker/DataLockerEventsTable';
import { PreviewItemsLayout } from '@/components/layout/PreviewItemsLayout';
import { VisualisationComponent } from '@/components/visualisations/PitchVisualisation/VisualisationComponent';
import { eventLinkAtom, samePageLink, videoLinkAtom } from '@/atoms/navigation';
import { useSetAtom } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { useEffect } from 'react';
import { dataLockerVisualisationComponents } from '../visComponents';

const SetLinkBehaviour = () => {
  const setVideoLink = useSetAtom(videoLinkAtom);
  const setEventLink = useSetAtom(eventLinkAtom);
  useEffect(() => {
    setVideoLink(samePageLink);
    setEventLink(samePageLink);
  }, []);
  return null;
};

export const DataLockerVideoPreview = () => (
  <ScopeProvider atoms={[videoLinkAtom, eventLinkAtom]}>
    <SetLinkBehaviour />
    <CardHeader>
      <ExpandVideoButton />
    </CardHeader>
    <PreviewItemsLayout>
      <VisualisationComponent allowInteraction visualisations={dataLockerVisualisationComponents} />
      <DataLockerEventsTable />
    </PreviewItemsLayout>
  </ScopeProvider>
);
